var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-input',{model:{value:(_vm.token),callback:function ($$v) {_vm.token=$$v},expression:"token"}}),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.doLogin}},[_vm._v(" 本地登录测试 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }